/* ==========================================================================
   STICKY BAR - DROPSHIP NOTE SYNC (added 10 Aug 2026)
   --------------------------------------------------------------------------
   The mobile sticky add-to-cart bar in sections/sim-product-main.liquid
   hardcodes the in-house subtext ("Free shipping over $150 - ships in 1
   business day") from the section setting sticky_subtext. Products with a
   dropship shipping note (custom.shipping_line, e.g. DOF Reality: ships from
   Europe in 2-3 weeks) already suppress the in-house claim in the main
   shipping line (snippets/sim-shipping-line.liquid) but the sticky bar does
   not know about the override. This script mirrors the first line of the
   dropship note into the sticky bar so the two surfaces never disagree.
   Loaded from layout/theme.liquid on product pages only.
   ========================================================================== */
(function () {
  function sync() {
    var note = document.querySelector('[data-sim-ship] .sim-ship__note');
    var sub = document.querySelector('.sim-sticky__sub');
    if (!note || !sub) return;
    var firstLine = (note.textContent || '').trim().split('\n')[0].trim();
    if (firstLine) sub.textContent = firstLine;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
